// extracted by mini-css-extract-plugin
module.exports = {"trigger":"SwitchUnits_trigger__2AuAH","select":"SwitchUnits_select__2XkQd"};